import { CheckCircle2 } from "lucide-react";

const POINTS = [
  "Formulações desenvolvidas por engenharia química aplicada",
  "Foco em performance, segurança e conformidade sanitária",
  "Atendimento consultivo — indicação do produto certo para o seu uso",
  "Embalagens de 20L e 200L pensadas para operação profissional",
];

export default function Sobre() {
  return (
    <section
      id="sobre"
      data-testid="sobre-section"
      className="relative bg-[#f5efe1] py-20 sm:py-28"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border-4 border-[#0e3b21]/10">
            <img
              src="/assets/metal-2.jpg"
              alt="Produtos Serequímica em operação"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 sm:-right-10 bg-[#0e3b21] text-white rounded-2xl p-6 shadow-2xl max-w-[260px]">
            <div
              className="text-4xl font-bold text-[#c9a24c]"
              style={{ fontFamily: "Playfair Display, serif" }}
            >
              +3
            </div>
            <div className="text-sm mt-1 text-white/85">
              linhas técnicas atendendo indústria, agro e alimentício.
            </div>
          </div>
        </div>

        <div>
          <div className="text-[#8a6b26] uppercase tracking-[0.25em] text-xs font-semibold">
            Sobre a Serequímica
          </div>
          <h2
            className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0e3b21] leading-tight"
            style={{ fontFamily: "Playfair Display, serif" }}
          >
            A química que trabalha <em className="text-[#8a6b26]">com você</em>,
            não contra o seu tempo.
          </h2>
          <div className="gold-underline mt-5" />
          <p className="mt-6 text-[#1a3a26]/85 text-base sm:text-lg leading-relaxed">
            A Serequímica é uma empresa pautada pela excelência em engenharia
            química aplicada. Desenvolvemos insumos de alta performance para
            frigoríficos, indústria metalmecânica e agronegócio — sempre com o
            mesmo compromisso: colocar a ciência a serviço da{" "}
            <strong className="text-[#0e3b21]">produtividade real</strong> do
            nosso cliente.
          </p>
          <p className="mt-4 text-[#1a3a26]/70 text-base leading-relaxed">
            Não vendemos apenas um produto — entregamos processo mais limpo,
            equipamento com vida útil maior e menos parada de operação. É por
            isso que quem experimenta, fica.
          </p>

          <ul className="mt-8 space-y-3">
            {POINTS.map((p) => (
              <li key={p} className="flex items-start gap-3">
                <CheckCircle2
                  size={20}
                  className="text-[#0e3b21] shrink-0 mt-0.5"
                  strokeWidth={2.2}
                />
                <span className="text-[#1a3a26] text-sm sm:text-base">{p}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
